/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PurchaseCancelBillCreateRespVo } from './PurchaseCancelBillCreateRespVo';
import {
    PurchaseCancelBillCreateRespVoFromJSON,
    PurchaseCancelBillCreateRespVoFromJSONTyped,
    PurchaseCancelBillCreateRespVoToJSON,
    PurchaseCancelBillCreateRespVoToJSONTyped,
} from './PurchaseCancelBillCreateRespVo';

/**
 * 
 * @export
 * @interface ResponsePurchaseCancelBillCreateRespVo
 */
export interface ResponsePurchaseCancelBillCreateRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePurchaseCancelBillCreateRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePurchaseCancelBillCreateRespVo
     */
    message?: string;
    /**
     * 
     * @type {PurchaseCancelBillCreateRespVo}
     * @memberof ResponsePurchaseCancelBillCreateRespVo
     */
    data?: PurchaseCancelBillCreateRespVo;
}

/**
 * Check if a given object implements the ResponsePurchaseCancelBillCreateRespVo interface.
 */
export function instanceOfResponsePurchaseCancelBillCreateRespVo(value: object): value is ResponsePurchaseCancelBillCreateRespVo {
    return true;
}

export function ResponsePurchaseCancelBillCreateRespVoFromJSON(json: any): ResponsePurchaseCancelBillCreateRespVo {
    return ResponsePurchaseCancelBillCreateRespVoFromJSONTyped(json, false);
}

export function ResponsePurchaseCancelBillCreateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePurchaseCancelBillCreateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PurchaseCancelBillCreateRespVoFromJSON(json['data']),
    };
}

export function ResponsePurchaseCancelBillCreateRespVoToJSON(json: any): ResponsePurchaseCancelBillCreateRespVo {
    return ResponsePurchaseCancelBillCreateRespVoToJSONTyped(json, false);
}

export function ResponsePurchaseCancelBillCreateRespVoToJSONTyped(value?: ResponsePurchaseCancelBillCreateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PurchaseCancelBillCreateRespVoToJSON(value['data']),
    };
}

